import Box from "@mui/material/Box";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import React from "react";
import Typography from "@mui/material/Typography";

const BorderLinearProgress = styled(LinearProgress)(({}) => ({
  height: 8,
  borderRadius: "4px",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "rgba(18, 99, 167, 0.2)",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "4px",
    backgroundColor: "#0090DA",
  },
}));

function LinearProgressWithLabel(props: { value: number }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
      <Box sx={{ width: "100%"}}>
        <BorderLinearProgress variant="determinate" {...props} />
      </Box>
    </Box>
  );
}

export default function LinearProgressEx({ progress }: any) {
  return (
    <Box sx={{ width: "100%" }}>
      <LinearProgressWithLabel value={progress} />
    </Box>
  );
}
